import React from 'react';
import {Segment, Responsive, Button, Header} from 'semantic-ui-react';


export default (props) => {
    return (
        <div>
        <Segment className="heading-container" basic clearing children={props.children} />
        <section id="home">
        <Segment style={{padding: "0.5rem"}} basic clearing>
            <Segment style={{padding: 0, margin: "1.5rem 0 0 0"}} basic clearing >
                {/* <Header className="header-container" compact floated="left" textAlign="left">
                    <Header.Content>
                        {props.lang.information_label}
                        <Header.Subheader className="subheader-container">
                            <span style={{color: "#E21F14"}} ><b>{props.lang.information_label_2}</b></span> <b>{props.lang.information_label_3}</b>
                        </Header.Subheader>
                    </Header.Content>
                    
                </Header> */}
                <Responsive minWidth={600}>
                    <Header className="dropdown-container" compact floated="right" textAlign="right">
                        {props.selectedLanguage !== "lithuanian"? <Button name="selectedLanguage" value="lithuanian" style={{background: "transparent", padding: 0, border: "none", boxShadow: "none"}} onClick={props.handleChange}><span class="icon-web">&nbsp;</span><b>Lietuvių</b></Button>
                        : <Button name="selectedLanguage" value="united kingdom" style={{ background: "transparent", padding: 0, border: "none", boxShadow: "none"}} onClick={props.handleChange}><span class="icon-web">&nbsp;</span><b>English</b></Button>}
                    </Header>
                </Responsive>
            </Segment>
            <Segment basic style={{padding: "0"}}>
                <Responsive maxWidth={599}>
                    <Header className="dropdown-container" compact floated="left" textAlign="left">
                        {props.selectedLanguage !== "lithuanian"? <Button name="selectedLanguage" value="lithuanian" style={{background: "transparent", padding: 0, border: "none", boxShadow: "none"}} onClick={props.handleChange}><span class="icon-web">&nbsp;</span><b>Lietuvių</b></Button>
                        : <Button name="selectedLanguage" value="united kingdom" style={{ background: "transparent", padding: 0, border: "none", boxShadow: "none"}} onClick={props.handleChange}><span class="icon-web">&nbsp;</span><b>English</b></Button>}
                    </Header>
                </Responsive>
            </Segment>
        </Segment>
        </section>

        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/heading/HeadingContainer.jsx